<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-card shadow="hover" class="mgb20" style="height: 252px">
                    <div class="user-info">
                        <img src="../../assets/img/userImg.png" class="user-avator" alt />
                        <div class="user-info-cont">
                            <div class="user-info-name">admin</div>
                            <div>管理员</div>
                        </div>
                    </div>
                    <div class="user-info-list">
                        上次登录时间：
                        <span>{{newDateSeven}}</span>
                    </div>
                    <div class="user-info-list">
                        上次登录地点：
                        <span>北京</span>
                    </div>
                </el-card>
                <el-card shadow="hover" style="height: 322px">
                    <div slot="header" class="clearfix fontSize">
                        <span class="msgTitle">设备状态</span>
                    </div>
                    <div class="canvaCover" ref="deviceStatus"></div>
                </el-card>
            </el-col>

            

            <el-col :span="16">
                <el-row :gutter="20" class="mgb20">
                    <el-col :span="24">
                        <el-carousel :autoplay="false" arrow="always" height="100px">
                            <el-carousel-item class="swiper">
                                <el-card
                                    shadow="hover"
                                    class="swiperItemCard"
                                    :body-style="{ padding: '0px' }"
                                >
                                    <div class="grid-content grid-con-1">
                                        <div class="grid-con-icon">
                                            <div class="iconfontSize iconfont icon-jinggai"></div>
                                            <div class="grid-con-deviceName">智能井盖</div>
                                        </div>
                                        <div class="grid-cont-right">
                                            <div class="grid-cont-right-list" style="color: #000">
                                                <div class="grid-num" style="color: #000">3</div>
                                                <div>设备总数</div>
                                            </div>
                                            <div
                                                class="grid-cont-right-list"
                                                style="color: #f5a623"
                                            >
                                                <div class="grid-num" style="color: #f5a623">0</div>
                                                <div>故障</div>
                                            </div>
                                            <div
                                                class="grid-cont-right-list"
                                                style="color: #ff5858"
                                            >
                                                <div class="grid-num" style="color: #ff5858">0</div>
                                                <div>报警</div>
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                                <!-- <el-card
                                    shadow="hover"
                                    class="swiperItemCard"
                                    :body-style="{ padding: '0px' }"
                                    v-for="item in deviceTypeCont"
                                    :key="item.type"
                                >
                                    <div class="grid-content grid-con-1">
                                        <div class="grid-con-icon">
                                            <div :class="'iconfontSize iconfont ' + item.iconFont"></div>
                                            <div class="grid-con-deviceName">{{ item.type }}</div>
                                        </div>
                                        <div class="grid-cont-right">
                                            <div class="grid-cont-right-list" style="color: #000">
                                                <div
                                                    class="grid-num"
                                                    style="color: #000"
                                                >{{ item.total }}</div>
                                                <div>设备总数</div>
                                            </div>
                                            <div
                                                class="grid-cont-right-list"
                                                style="color: #f5a623"
                                            >
                                                <div
                                                    class="grid-num"
                                                    style="color: #f5a623"
                                                >{{ item.troule }}</div>
                                                <div>故障</div>
                                            </div>
                                            <div
                                                class="grid-cont-right-list"
                                                style="color: #ff5858"
                                            >
                                                <div
                                                    class="grid-num"
                                                    style="color: #ff5858"
                                                >{{ item.alarm }}</div>
                                                <div>报警</div>
                                            </div>
                                        </div>
                                    </div>
                                </el-card>-->
                            </el-carousel-item>
                        </el-carousel>
                    </el-col>
                </el-row>
                <el-card shadow="hover" style="height: 473px">
                    <div slot="header" class="clearfix fontSize">
                        <span class="msgTitle">消息中心</span>
                    </div>
                    <el-table :show-header="false" :data="messageData" style="width: 100%">
                        <el-table-column>
                            <template slot-scope="scope">
                                <div
                                    class="todo-item"
                                    :class="{ 'todo-item-del': scope.row.status }"
                                >[设备打开报警] 设备ID:{{ scope.row.id }} 报警时间:{{ scope.row.failDate}}</div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column width="60">
                            <template slot-scope="scope">
                                <i
                                    class="el-icon-delete"
                                    style="color: red; cursor: pointer"
                                    title="删除"
                                    @click="notificTrue(scope.row)"
                                ></i>
                            </template>
                        </el-table-column>-->
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-card shadow="hover">
                    <!-- <schart ref="bar" class="schart" canvasId="bar" :options="options"></schart> -->
                    <div class="schart" ref="bar"></div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card shadow="hover">
                    <!-- <schart ref="line" class="schart" canvasId="line" :options="options2"></schart> -->
                    <div class="schart" ref="line"></div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>



<script>
import Schart from 'vue-schart';
import bus from '../common/bus';
import { Bigscreen } from '../../api';
import moment from 'moment';
export default {
    name: 'dashboard',
    data() {
        return {
            newDateSeven: '',
            messageData: [],
            notificData: [],
            deviceTypeCont: [],

            name: localStorage.getItem('ms_username'),
            data: [
                {
                    name: '2018/09/04',
                    value: 1083
                },
                {
                    name: '2018/09/05',
                    value: 941
                },
                {
                    name: '2018/09/06',
                    value: 1139
                },
                {
                    name: '2018/09/07',
                    value: 816
                },
                {
                    name: '2018/09/08',
                    value: 327
                },
                {
                    name: '2018/09/09',
                    value: 228
                },
                {
                    name: '2018/09/10',
                    value: 1065
                }
            ],
            options: {
                type: 'bar',
                title: {
                    text: '最近一周设备状态情况'
                },
                xRorate: 25,
                labels: ['周一', '周二', '周三', '周四', '周五'],
                datasets: [
                    {
                        label: '在线',
                        data: [234, 278, 270, 190, 230]
                    },
                    {
                        label: '异常',
                        data: [164, 178, 190, 135, 160]
                    },
                    {
                        label: '报警',
                        data: [144, 198, 150, 235, 120]
                    }
                ]
            },
            options2: {
                type: 'line',
                title: {
                    text: '最近几个月设备状态趋势图'
                },
                labels: ['6月', '7月', '8月', '9月', '10月'],
                datasets: [
                    {
                        label: '在线',
                        data: [234, 278, 270, 190, 230]
                    },
                    {
                        label: '异常',
                        data: [164, 178, 150, 135, 160]
                    },
                    {
                        label: '报警',
                        data: [74, 118, 200, 235, 90]
                    }
                ]
            }
        };
    },
    mounted() {
        setTimeout(() => {
            let myChart = this.$echarts.init(this.$refs.deviceStatus);
            // 绘制设备占比统计图表
            myChart.setOption({
                grid: {
                    bottom: 25
                },
                title: {
                    text: '设备状态统计',
                    left: 'center',
                    textStyle: {
                        color: '#ffffff'
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    textStyle: {
                        color: '#000000'
                    }
                },
                series: [
                    {
                        name: '设备状态数量',
                        type: 'pie',
                        radius: '60%',
                        data: this.statusComputer(),
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });

            let one = this.$echarts.init(this.$refs.bar);
            let two = this.$echarts.init(this.$refs.line);
            // 每日设备状态折线图
            one.setOption({
                title: {
                    text: '每日设备状态折线图',
                    textStyle: {
                        color: '#000000'
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['正常', '故障', '报警'],
                    textStyle: {
                        color: '#000000'
                    }
                },
                grid: {
                    bottom: 25
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.beforDeviceDataComputerLine().xData,
                    textStyle: {
                        color: '#000000'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: this.beforDeviceDataComputerLine().vSeries
            });

            // 每日设备状态柱状图
            two.setOption({
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                title: {
                    text: '每日设备状态柱状图',
                    textStyle: {
                        color: '#000000'
                    }
                },
                grid: {
                    bottom: 25
                },
                tooltip: {},
                legend: {
                    textStyle: {
                        color: '#000000'
                    }
                },
                xAxis: {
                    data: this.beforDeviceDataComputerBar().xData
                },
                yAxis: {},
                series: this.beforDeviceDataComputerBar().vSeries
            });
        }, 50);
    },
    components: {
        Schart
    },
    computed: {
        role() {
            return this.name === 'admin' ? '超级管理员' : '普通用户';
        }
    },
    activated() {
        this.swiperDeviceComputer();
        this.notificDataComputer();
    },
    created() {
        this.getDeviceData();
        // 设置过往七天数据
        // 过去八天的日期 包含今天
        let dateSeven = this.getLastOrNextFewDateBy(new Date());
        let newDateSeven = [];
        newDateSeven.push([dateSeven[0], dateSeven[1], dateSeven[2], dateSeven[3], dateSeven[4], dateSeven[5], dateSeven[6]]);
        console.log(newDateSeven);
        this.newDateSeven = dateSeven[7];

        this.$store.commit('setDeviceBefore', [
            {
                date: dateSeven[0],
                normal: 3,
                alarm: 0,
                troule: 0
            },
            {
                date: dateSeven[1],
                normal: 3,
                alarm: 0,
                troule: 0
            },
            {
                date: dateSeven[2],
                normal: 3,
                alarm: 0,
                troule: 0
            },
            {
                date: dateSeven[3],
                normal: 3,
                alarm: 0,
                troule: 0
            },
            {
                date: dateSeven[4],
                normal: 3,
                alarm: 0,
                troule: 0
            },
            {
                date: dateSeven[5],
                normal: 3,
                alarm: 0,
                troule: 0
            },
            {
                date: dateSeven[6],
                normal: 3,
                alarm: 0,
                troule: 0
            }
        ]);

        this.swiperDeviceComputer();
        this.notificDataComputer();
    },
    // activated() {
    //     this.handleListener();
    // },
    // deactivated() {
    //     window.removeEventListener('resize', this.renderChart);
    //     bus.$off('collapse', this.handleBus);
    // },
    methods: {
        // // 获取设备数据
        async getDeviceData() {
            let DevicelistResult = await Bigscreen();
            if (DevicelistResult.status !== 1) {
                this.$message.error('获取设备数据错误');
                return;
            }
            let allArr = [];
            DevicelistResult.message.forEach((item, index) => {
                let obj = JSON.parse(item);
                obj.Details = JSON.parse(JSON.parse(item).Details);
                allArr.push(obj);
            });

            allArr.forEach((item, index) => {
                let arr = [];
                allArr[index].DetailsValue = [];
                for (const key in item.Details.data) {
                    for (const inkey in item.Details.model) {
                        if (key == inkey) {
                            if (item.Details.data[key] === false || item.Details.data[key] === true) {
                                allArr[index].DetailsValue.push([key, item.Details.model[key], item.Details.data[key] ? '是' : '否']);
                            } else {
                                allArr[index].DetailsValue.push([key, item.Details.model[key], item.Details.data[key]]);
                            }
                        }
                    }
                }
            });
            // 设备数据处理完成
            this.deviceData = allArr;
            // 修改vuex中的设备数据
            this.$store.commit('setDeviceNowData', allArr);

            // 处理设备状态统计所需数据并渲染
            // this.statusComputer(allArr);

            // 判断是否有设备被打开 如果打开则修改报警记录
            let messageArr = [];
            allArr.forEach((item, index) => {
                if (item.Details.data.cover_status) {
                    messageArr.push({
                        messageId: index,
                        type: 'alarm',
                        id: item.Details.data.device_id,
                        lat: item.longitude * 1,
                        lng: item.latitude * 1,
                        failDate: moment().format('MM/DD H:mm '),
                        successDate: '',
                        status: 0
                    });
                }
            });
            this.$store.commit('setAlarmMessage', messageArr);

            this.messageData = this.$store.state.deviceMessage;
            console.log(this.messageData);
        },

        // 获取过去七天日期包含今天
        getLastOrNextFewDateBy(value) {
            this.timeList = [];
            let timedate = value !== '' ? value : this.bigtime !== '' ? this.bigtime : '';
            for (let i = -7; i <= 0; i++) {
                let today = new Date();
                if (timedate) {
                    this.receiver = timedate;
                } else {
                    this.receiver = today;
                }
                let lastOrNextDate = this.receiver.getTime() + 1000 * 60 * 60 * 24 * i;
                today.setTime(lastOrNextDate);
                // var year = today.getFullYear();
                let month = today.getMonth() + 1;
                if (this.receiver == timedate) {
                    let date = today.getDate();
                    if (date < 10) {
                        date = '0' + date;
                    }
                    if (month < 10) {
                        month = '0' + month;
                    }
                    this.timeList.push(month + '-' + date);
                } else {
                    let date = today.getDate() - 1;
                    if (date < 10) {
                        date = '0' + date;
                    }
                    if (month < 10) {
                        month = '0' + month;
                    }
                    this.timeList.push(month + '-' + date);
                }
                // this.timeList.push(i != 0 ? month + "月" + date + '日' : '本日')
                // this.timeList.push(month + "月" + date + '日')
            }
            return this.timeList;
        },

        // 每日设备状态折线图数据处理
        beforDeviceDataComputerLine() {
            let arr = this.$store.state.deviceBefore;
            let xData = arr.map(item => {
                return item.date;
            });
            let vSeries = [];
            // let normalObj = {};
            // let alarmObj = {};
            // let trouleObj = {};
            let normalDataArr = [];
            let alarmDataArr = [];
            let trouleDataArr = [];
            this.$store.state.deviceBefore.forEach(item => {
                normalDataArr.push(item.normal);
                alarmDataArr.push(item.alarm);
                trouleDataArr.push(item.troule);
            });
            // vSeries.push(normalObj,alarmObj,trouleObj)

            vSeries.push({
                name: '正常',
                type: 'line',
                itemStyle: {
                    color: '#08d97b'
                },
                data: normalDataArr
            });

            vSeries.push({
                name: '报警',
                type: 'line',
                itemStyle: {
                    color: '#e83c03'
                },
                data: alarmDataArr
            });
            vSeries.push({
                name: '故障',
                type: 'line',
                itemStyle: {
                    color: '#ff8115'
                },
                data: trouleDataArr
            });
            return {
                xData,
                vSeries
            };
        },
        // 每日设备状态柱状图数据处理
        beforDeviceDataComputerBar() {
            let arr = this.$store.state.deviceBefore;
            let xData = arr.map(item => {
                return item.date;
            });
            let vSeries = [];
            let normalDataArr = [];
            let alarmDataArr = [];
            let trouleDataArr = [];
            this.$store.state.deviceBefore.forEach(item => {
                normalDataArr.push(item.normal);
                alarmDataArr.push(item.alarm);
                trouleDataArr.push(item.troule);
            });
            vSeries.push({
                name: '正常',
                type: 'bar',
                itemStyle: {
                    color: '#08d97b'
                },
                data: normalDataArr
            });

            vSeries.push({
                name: '报警',
                type: 'bar',
                itemStyle: {
                    color: '#e83c03'
                },
                data: alarmDataArr
            });
            vSeries.push({
                name: '故障',
                type: 'bar',
                itemStyle: {
                    color: '#ff8115'
                },
                data: trouleDataArr
            });
            console.log(vSeries);

            return {
                xData,
                vSeries
            };
        },

        // 消息中心数据
        notificDataComputer() {
            let arr = [];
            this.$store.state.notific.forEach(item => {
                if (!item.status) {
                    arr.push(item);
                }
            });
            this.notificData = arr;
        },
        notificTrue(e) {
            this.$confirm('确认删除该条消息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$store.commit('delNotific', e.id);
                    this.notificDataComputer();
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 滑动栏设备状态数据处理
        swiperDeviceComputer() {
            let deviceAllData = this.$store.state.deviceNowData;
            let jinggai = [];
            let lajitong = [];
            let shuiwei = [];
            // 筛选出设备种类
            deviceAllData.forEach(item => {
                switch (item.deviceType) {
                    case '智能井盖':
                        jinggai.push(item);
                        break;
                    case '智慧垃圾桶':
                        lajitong.push(item);
                        break;
                    case '水位监测':
                        shuiwei.push(item);
                        break;
                    default:
                        break;
                }
            });
            let jingGaiObj = {
                type: '智能井盖',
                total: jinggai.length,
                alarm: 0,
                troule: 0,
                iconFont: 'icon-jinggai'
            };
            let laJiTongObj = {
                type: '智慧垃圾桶',
                total: lajitong.length,
                alarm: 0,
                troule: 0,
                iconFont: 'icon-icon'
            };
            let shuiweiObj = {
                type: '水位监测',
                total: shuiwei.length,
                alarm: 0,
                troule: 0,
                iconFont: 'icon-shuiwei'
            };
            jinggai.forEach(item => {
                switch (item.status) {
                    case '故障':
                        jingGaiObj.troule += 1;
                        break;
                    case '报警':
                        jingGaiObj.alarm += 1;
                        break;
                    default:
                        break;
                }
            });
            shuiwei.forEach(item => {
                switch (item.status) {
                    case '故障':
                        shuiweiObj.troule += 1;
                        break;
                    case '报警':
                        shuiweiObj.alarm += 1;
                        break;
                    default:
                        break;
                }
            });
            lajitong.forEach(item => {
                switch (item.status) {
                    case '故障':
                        laJiTongObj.troule += 1;
                        break;
                    case '报警':
                        laJiTongObj.alarm += 1;
                        break;
                    default:
                        break;
                }
            });
            // let arrs = [jingGaiObj, laJiTongObj,shuiweiObj];
            let arrs = [shuiweiObj];
            this.deviceTypeCont = arrs;
        },
        // 统计设备状态数据处理
        statusComputer() {
            let arr = [];
            console.log(this.$store.state.deviceNowData);
            arr = this.$store.state.deviceNowData.map(item => {
                console.log(item.DeviceStatus);
                switch (item.Device_status) {
                    case 0:
                        return '正常';
                        break;
                    case 1:
                        return '故障';
                        break;
                    case 2:
                        return '维护';
                        break;

                    default:
                        break;
                }
            });

            let obj = {};
            for (let i = 0; i < arr.length; i++) {
                var item = arr[i];
                obj[item] = obj[item] + 1 || 1;
            }
            console.log(obj);
            let computerData = [];
            for (const key in obj) {
                switch (key) {
                    case '正常':
                        computerData.push({
                            name: key,
                            value: obj[key],
                            itemStyle: {
                                color: '#08d97b'
                            }
                        });
                        break;
                    case '故障':
                        computerData.push({
                            name: key,
                            value: obj[key],
                            itemStyle: {
                                color: '#ff8115'
                            }
                        });
                        break;
                    case '维护':
                        computerData.push({
                            name: key,
                            value: obj[key],
                            itemStyle: {
                                color: '#e83c03'
                            }
                        });
                        break;

                    default:
                        break;
                }
            }
            console.log('computerData');
            console.log(computerData);
            let computerDataObj = {
                normal: 0,
                trouble: 0,
                maintail: 0
            };
            computerData.forEach(item => {
                switch (item.name) {
                    case '正常':
                        computerDataObj.normal = item.value;
                        break;
                    case '故障':
                        computerDataObj.trouble = item.value;
                        break;
                    case '维护':
                        computerDataObj.maintail = item.value;
                        break;

                    default:
                        break;
                }
            });
            this.computerDataObj = computerDataObj;

            return computerData;
        },
        changeDate() {
            const now = new Date().getTime();
            this.data.forEach((item, index) => {
                const date = new Date(now - (6 - index) * 86400000);
                item.name = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
            });
        }
        // handleListener() {
        //     bus.$on('collapse', this.handleBus);
        //     // 调用renderChart方法对图表进行重新渲染
        //     window.addEventListener('resize', this.renderChart);
        // },
        // handleBus(msg) {
        //     setTimeout(() => {
        //         this.renderChart();
        //     }, 200);
        // },
        // renderChart() {
        //     this.$refs.bar.renderChart();
        //     this.$refs.line.renderChart();
        // }
    }
};
</script>


<style scoped lang="less">
.el-row {
    margin-bottom: 20px;
}

.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.grid-cont-right {
    flex: 1;
    text-align: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
    color: #999;
}

.grid-num {
    font-size: 30px;
    font-weight: bold;
}

.grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
}
.grid-con-deviceName {
    font-size: 18px;
}
.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
    color: rgb(242, 94, 67);
}

.user-info {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
}

.user-avator {
    width: 120px;
    height: 120px;
    border-radius: 50%;
}

.user-info-cont {
    padding-left: 50px;
    flex: 1;
    font-size: 14px;
    color: #999;
}

.user-info-cont div:first-child {
    font-size: 30px;
    color: #222;
}

.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
}

.user-info-list span {
    margin-left: 70px;
}

.mgb20 {
    margin-bottom: 20px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}

.schart {
    width: 100%;
    height: 300px;
}
.swiper {
    display: flex;
    justify-content: flex-start;
}
.swiperItemCard {
    width: 32%;
    margin-right: 10px;
}
.iconfontSize {
    font-size: 50px;
}
.msgTitle {
    font-size: 16px;
}
.canvaCover {
    width: 100%;
    height: 200px;
}
.fontSize {
    font-size: 16px;
}
</style>
